import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NouisliderModule } from "ng2-nouislider";
import { TagInputModule } from "ngx-chips";
import { MaterialModule } from "../app.module";
import { ComponentsModule } from "../shared/components/components.module";

// import { SaleTermsComponent } from './sale-terms/sale-terms.component';
import { NetTermsRoutes } from "./net-terms.routing";
// import { PurchaseTermsComponent } from "./purchase-terms/purchase-terms.component";

@NgModule({
  // declarations: [PurchaseTermsComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(NetTermsRoutes),
    FormsModule,
    ReactiveFormsModule,
    NouisliderModule,
    TagInputModule,
    MaterialModule,
    ComponentsModule,
  ],
  // exports: [SaleTermsComponent]
})
export class NetTermsModule {}
